module.exports = __webpack_public_path__ + "img/172.953cf98b.jpg";